import React from 'react'

export default function RefundOrder({ order }) {
  return (
    <>
      <table className="table">
        <thead>
          <tr>
            <th>หมายเลขคำสั่งซื้อ</th>
            <th>วันที่สั่งซื้อ</th>
            <th>ลูกค้า</th>
            <th>สถานะคำสั่งซื้อ</th>
            <th>ราคา</th>
            <th>เบอร์โทรศัพท์</th>
          </tr>
        </thead>
        <tbody>
          {order && (
            <tr>
              <td>{order.refNo}</td>
              <td>{new Date(order.createdAt).toLocaleString('TH-th')}</td>
              <td>{`${order.userFirstName} ${order.userLastName}`}</td>
              <td>{order.status}</td>
              <td>{order.totalPrice}</td>
              <td>{order.userPhone}</td>
            </tr>
          )}
          {/* {orders.map(order => (<tr>
            <td>{order.refNo}</td>
            <td>{new Date(order.createdAt._seconds * 1000).toLocaleString("TH-th")}</td>
            <td>{`${order.userFirstName} ${order.userLastName}`}</td>
            <td>{order.status}</td>
            <td>{order.totalPrice}</td>
            <td>{order.userPhone}</td>
          </tr>))} */}
        </tbody>
      </table>
    </>
  )
}
